import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    loai_doi_tuong: null, //string, optional // Loại đối tượng với các giá trị hợp lệ: tour_guide|customer|place
    user_id: null, //IdRef, optional // Mã người dùng
    chuong_trinh_id: null, //IdRef, optional // Mã người dùng
    du_lieu_khai_bao: {}, //object, optional // Dữ liệu khai báo khi đăng ký chương trình
    // huy_hieu_ids: [], //array of IdRef, optional // Danh sách huy hiệu user
    da_duyet: null, //boolean, optional // Trạng thái đã duyệt thành tích huy hiệu cho chương trình hay chưa
    thoi_diem_tao: null, //datetime, optional // Thời điểm tạo
    thoi_diem_cap_nhat: null, //datetime, optional // Thời điểm cập nhật
    nguoi_tao_id: null, //IdRef, optional // Mã người tạo
};

// validation form
model.validForm = {
    loai_doi_tuong: [], //string, optional // Loại đối tượng với các giá trị hợp lệ: tour_guide|customer|place
    user_id: [], //IdRef, optional // Mã người dùng
    chuong_trinh_id: [], //IdRef, optional // Mã người dùng
    du_lieu_khai_bao: [], //object, optional // Dữ liệu khai báo khi đăng ký chương trình
    // huy_hieu_ids: [], //array of IdRef, optional // Danh sách huy hiệu user
    da_duyet: [], //boolean, optional // Trạng thái đã duyệt thành tích huy hiệu cho chương trình hay chưa
    thoi_diem_tao: [], //datetime, optional // Thời điểm tạo
    thoi_diem_cap_nhat: [], //datetime, optional // Thời điểm cập nhật
    nguoi_tao_id: [], //IdRef, optional // Mã người tạo

};

// dữ liệu mẫu các form khác
model.dataFormOther = {};

// validation các form khác
model.validFormOther = {};

model.loaiDoiTuong = [{
    code: "tour_guide",
    text: "Hướng dẫn viên"
},
{
    code: "customer",
    text: "Khách du lịch"
},
{
    code: "place",
    text: "Điểm đến"
},
];

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["thoi_diem_tao", "descending"],
    filters: "loai_doi_tuong:in:tour_guide",
    recordSelected: [],
    dataSearch: {
        value: {
            loai_doi_tuong: "tour_guide", 
            user_id: "",
            chuong_trinh_id: "", 
            // du_lieu_khai_bao: "" , 
            huy_hieu_ids: "", 
            da_duyet: "", 
            thoi_diem_tao: "", 
            thoi_diem_cap_nhat: "", 
            nguoi_tao_id: ""

        },
        valid: {
            loai_doi_tuong: [], 
            user_id: [],
            chuong_trinh_id: [], 
            // du_lieu_khai_bao: [] , 
            huy_hieu_ids: [], 
            da_duyet: [], 
            thoi_diem_tao: [], 
            thoi_diem_cap_nhat: [], 
            nguoi_tao_id: []
        },
        operator: {
            // ma: ":regex:",
            // 'ten.vi': ":regex_i:", //:regex:, $vn_text=Viêt nam
            // 'ten.en': ":regex_i:"
            thoi_diem_tao:":in_that_day:"
        }
    }
};

export default model;